import { Failure } from '../../entities/Failure';
import { Success } from '../../entities/Success';
import api from '../api';

export const updateLoyaltyProgram = async (formData) => {
  try {
    if (!formData?.Id || !['string', 'number'].includes(typeof formData.Id)) {
      throw new Error('invalid data');
    }

    const { data } = await api.patch(`/loyalty/program/${formData.Id}`, formData);

    return new Success(data);
  } catch (error) {
    console.log(error);
    return new Failure();
  }
};
